import { checkUnmanagedAppPermissions } from '@repo/guards/route-checks';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/org/$organization/unmanaged-applications/new')({
    beforeLoad: async (param)=>{
        let { params, context: { queryClient } } = param;
        const can = await checkUnmanagedAppPermissions(queryClient, params.organization);
        if (!(can === null || can === void 0 ? void 0 : can.createUnmanagedApplication)) {
            throw redirect({
                to: '/403',
                search: {
                    from: '/org/$organization/unmanaged-applications/new'
                }
            });
        }
    }
});
